export default "__VITE_ASSET__454985bf__"